export const generateId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  let uuid = '';
  for (let i = 0; i < template.length; i += 1) {
    const char = template[i];
    if (char === 'x' || char === 'y') {
      const random = Math.random() * 16 | 0;
      const value = char === 'x' ? random : (random & 0x3) | 0x8;
      uuid += value.toString(16);
    } else {
      uuid += char;
    }
  }
  return uuid;
};
